// i18n keys of the multi-tenant work package "proptax" (en / zh / th) — owner Q12: the accounting firm's
// property-tax fee per property and the notice's due date (Admin → Companies → Billing & reminders card,
// Property Tax tab). ⛔ Fill all three: an empty th value falls back to English.
export const en: Record<string, string> = {
  bc_g_proptax: 'Property tax',
  bc_f_propTaxFee: 'Service fee per property',
  bc_f_propTaxDueMmdd: 'Payment due date (each tax year)',
  bc_u_amount: 'amount per property, home currency',
  bc_u_mmdd: 'month-day, MM-DD',
  bc_ph_mmdd: 'MM-DD',
  bc_no_default: 'no default — empty = not set',
  bc_proptax_note: 'Used by the Property Tax tab and the payment-request email: the fee × the number of properties, due on this day of the tax year. A client\'s own fee and each email\'s due date can still be changed. Empty fee = not set: the tab shows "not set" and the payment request of a client without its own fee is refused. Empty date = the email\'s due date starts blank.',
  pt_fee_not_set: 'not set',
  pt_fee_not_set_banner: 'The service fee per property is not set — rows without their own fee show "not set" and their payment request cannot be prepared. Set it in Admin → Companies → {{firm}} → {{card}} → {{group}}, or type the client\'s own fee in the row.',
  pt_total_unknown: 'Total unknown — the service fee is not set',
  bc_use_defaults_keeps: 'Property tax is kept: it has no default. Empty its fields one by one to clear them.',
};
export const zh: Record<string, string> = {
  bc_g_proptax: '房产税',
  bc_f_propTaxFee: '每处房产服务费',
  bc_f_propTaxDueMmdd: '缴款截止日（每个税年）',
  bc_u_amount: '每处房产的金额（本位币）',
  bc_u_mmdd: '月-日，MM-DD',
  bc_ph_mmdd: 'MM-DD',
  bc_no_default: '无默认值——留空即未设置',
  bc_proptax_note: '用于房产税页签和缴款通知邮件：服务费 × 房产数量，截止日为该税年的这一天。每个客户自己的服务费、每封邮件的截止日仍可单独修改。服务费留空 = 未设置：页签显示「未设置」，没有自填服务费的客户无法生成缴款通知。日期留空 = 邮件里的截止日为空白。',
  pt_fee_not_set: '未设置',
  pt_fee_not_set_banner: '每处房产服务费未设置——没有自填服务费的行显示「未设置」，其缴款通知无法生成。请在 管理 → 公司 → {{firm}} → {{card}} → {{group}} 设置，或在该行填写客户自己的服务费。',
  pt_total_unknown: '合计未知——服务费未设置',
  bc_use_defaults_keeps: '房产税不会被清空：它没有默认值。如需清除，请逐个清空其字段。',
};
export const th: Record<string, string> = {
  bc_g_proptax: 'ภาษีที่ดินและสิ่งปลูกสร้าง',
  bc_f_propTaxFee: 'ค่าบริการต่อทรัพย์สินหนึ่งแห่ง',
  bc_f_propTaxDueMmdd: 'วันครบกำหนดชำระ (ทุกปีภาษี)',
  bc_u_amount: 'จำนวนเงินต่อทรัพย์สิน สกุลเงินหลัก',
  bc_u_mmdd: 'เดือน-วัน, MM-DD',
  bc_ph_mmdd: 'MM-DD',
  bc_no_default: 'ไม่มีค่าเริ่มต้น — เว้นว่าง = ยังไม่ได้ตั้งค่า',
  bc_proptax_note: 'ใช้ในแท็บภาษีที่ดินฯ และอีเมลแจ้งชำระ: ค่าบริการ × จำนวนทรัพย์สิน ครบกำหนดในวันนี้ของปีภาษี ค่าบริการของลูกค้าแต่ละรายและวันครบกำหนดของแต่ละอีเมลยังแก้ไขได้ หากเว้นค่าบริการว่าง = ยังไม่ได้ตั้งค่า: แท็บจะแสดง "ยังไม่ได้ตั้งค่า" และจะเตรียมอีเมลแจ้งชำระของลูกค้าที่ไม่มีค่าบริการของตนเองไม่ได้ หากเว้นวันที่ว่าง = วันครบกำหนดในอีเมลจะว่างไว้',
  pt_fee_not_set: 'ยังไม่ได้ตั้งค่า',
  pt_fee_not_set_banner: 'ยังไม่ได้ตั้งค่าบริการต่อทรัพย์สิน — แถวที่ไม่มีค่าบริการของตนเองจะแสดง "ยังไม่ได้ตั้งค่า" และเตรียมอีเมลแจ้งชำระไม่ได้ ตั้งค่าได้ที่ ผู้ดูแลระบบ → บริษัท → {{firm}} → {{card}} → {{group}} หรือใส่ค่าบริการของลูกค้าในแถวนั้น',
  pt_total_unknown: 'ยังไม่ทราบยอดรวม — ยังไม่ได้ตั้งค่าบริการ',
  bc_use_defaults_keeps: 'ภาษีที่ดินและสิ่งปลูกสร้างจะไม่ถูกล้าง เพราะไม่มีค่าเริ่มต้น หากต้องการล้าง ให้ลบค่าในแต่ละช่องเอง',
};
